import { get, post } from "./rest";

const slackMessagesRoot = "/slackMessages/";

export async function info(messageId: string): Promise<any> {
  return await post(`${slackMessagesRoot}info`, { messageId });
}

export function list(params: {
  userIds?: string[];
  orgId?: string;
  exclude?: string[];
}): Promise<any[]> {
  const query = new URLSearchParams();
  if (params.userIds) {
    query.append("userIds", params.userIds.join(","));
  }
  if (params.orgId) {
    query.append("orgId", params.orgId);
  }
  if (params.exclude) {
    query.append("exclude", params.exclude.join(","));
  }
  return get(`${slackMessagesRoot}?${query.toString()}`);
}
